export default "__VITE_ASSET__CPFrFKjq__"